import { View, type ViewStyle } from 'react-native';
import { ActivityIndicator } from 'react-native-paper';

import { spacing, useAppTheme } from '@/theme';

interface LoadingStateProps {
  readonly testID?: string;
}

const style: ViewStyle = {
  flex: 1,
  alignItems: 'center',
  justifyContent: 'center',
  padding: spacing[6],
};

export const LoadingState = ({ testID }: LoadingStateProps) => {
  const { colors } = useAppTheme();

  return (
    <View style={style} testID={testID}>
      <ActivityIndicator color={colors.iconNdPrimary} size="large" />
    </View>
  );
};
